import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { ArrowUpRight } from "@phosphor-icons/react";

const LOGO = "/logo-geekcreative.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || "Something went wrong. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white text-[var(--gc-navy)] flex flex-col">
      <header className="border-b border-[var(--gc-border)] px-8 h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img src={LOGO} alt="GeekCreative" className="h-16 md:h-20 w-auto block" />
        </Link>
        <div className="text-sm text-[var(--gc-text-muted)]">
          Remembered it? <Link to="/login" className="link-underline text-[var(--gc-navy)] font-semibold" data-testid="back-to-login-link">Sign in</Link>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center p-8 lg:p-16">
        <div className="w-full max-w-md">
          <div className="eyebrow mb-4">Password reset</div>
          <h1 className="font-display text-5xl md:text-6xl">Forgot<br/>password?</h1>
          <p className="text-[var(--gc-text-muted)] mt-4">
            Enter your account email and we&apos;ll send a secure reset link. The link expires in 1&nbsp;hour.
          </p>

          {sent ? (
            <div className="mt-10 border-l-2 border-[var(--gc-success)] bg-green-50 p-5" data-testid="forgot-success">
              <div className="eyebrow text-[var(--gc-success)] mb-2">Check your email</div>
              <p className="text-sm text-[var(--gc-navy)]">
                If <strong>{email}</strong> is on file, a reset link is on its way. It can take a minute or two to arrive.
              </p>
              <Link to="/login" className="btn-solid mt-6" data-testid="back-to-login-btn">
                Back to sign in <ArrowUpRight size={16} weight="bold" />
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-10 space-y-8" data-testid="forgot-form">
              {err && <div className="border-l-2 border-[var(--gc-danger)] bg-red-50 text-[var(--gc-danger)] p-3 text-sm" data-testid="forgot-error">{err}</div>}
              <div>
                <div className="eyebrow mb-2">Email</div>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  required
                  className="gc-input"
                  data-testid="forgot-email"
                  placeholder="you@example.com"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-solid w-full justify-center disabled:opacity-50"
                data-testid="forgot-submit"
              >
                {loading ? "Sending…" : <>Send reset link <ArrowUpRight size={16} weight="bold" /></>}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
